import React, { Component } from 'react';
import { GoogleMap, LoadScript, DrawingManager  } from '@react-google-maps/api';
import {
  Segment,
} from "semantic-ui-react";
import { AppContext } from "../../utils/context";

const mapContainerStyle  = {
  width: '1450px',
  height: '600px'
};

const center = { lat: 43.65107, lng: -79.347015 }
const libraries = ['drawing'];
class GoogleMapDrawingManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      isLoading: true,
      drawingMode: true,
      coords: [],
      drawingControlOptions: { drawingModes: ['polygon'] }
    };
  }

   onPolygonComplete  = (polygon) => {
    const paths = polygon.getPath().getArray();
    if (paths.length < 3) {
         polygon.setPaths([]);
         alert("You need to enter at least 3 points.")
    } else {
        const coords = paths.map((a) => [a.lat(), a.lng()]);
        this.setState({
          drawingMode: null,
          coords: coords
        });
    } 
  }

  render() {
    const {
      coords
    } = this.state
    return (
<Segment basic >
  <div className="googlemap">
      <div className='coords_output'>
      {coords.map((d, key) => (
        <li key={ 'latlng' + key }>{d[1]+' ,'+d[0]}</li>
      ))} 
      </div>
      <LoadScript googleMapsApiKey={this.context.config.google_api_key} libraries={libraries}>
        <GoogleMap
          id="drawing-manager-example"
          mapContainerStyle={mapContainerStyle}
          zoom={5}
          center={center}
        >
          <DrawingManager
            drawingMode={this.state.drawingMode}
            onPolygonComplete ={this.onPolygonComplete }
            options={{
              drawingControl: true,
              drawingControlOptions: { drawingModes: ['polygon'] },
              polygonOptions: {
                fillColor: "#199ee0",
                strokeWeight: 2,
                strokeColor: "#113460",
                clickable: true,
                editable: true,
                geodesic: false,
                visible: true,
                zIndex: 1
              }
            }}
          />
        </GoogleMap>
      </LoadScript>
  </div>
</Segment>
    )
  }
}

export default GoogleMapDrawingManager;
GoogleMapDrawingManager.contextType = AppContext;